// extracted by mini-css-extract-plugin
module.exports = {"Error":"Orders_Error__wMAFx","Btn":"Orders_Btn__2-rKb"};